import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "rsuite/dist/rsuite.min.css";
import DatePicker from "react-datepicker";
import { useDispatch } from "react-redux";
import { Box, Tooltip } from "@chakra-ui/react";
import { FaTrash } from "react-icons/fa6";
import { InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { TbListDetails } from "react-icons/tb";
import { fetchAsyncGetPaymentNum } from "redux/invoicePaymentRecordSlice";
import { pmtNumberFormate } from "jsFunctions/helperFunctions";
import PaymentReceiptPdf from "../PaymentReceipt/paymentReceiptPdf";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import VendorCustomSelect from "components/allForm/Vendors/VendorCustomSelect";
import { allPaymentMode } from "components/allForm/PurchaseItem/selectedOptions";
import DrawerButton from "components/allForm/component/buttons/drawerButton";
import CustomSelect from "components/CustomSelect";


const PaymentRecords = (props) => {
  const { autoCount,recordData,paymentRecordError,editData,expenseType, role,handleOnChange,currency,deleteRecord,totalReceivableAmt,bankOptions} = props;

  const [pmtPrfx,setPmtPrfx] = useState({
    prfx:'PMT-',
    m: new Date().getMonth() + 1,
    y: new Date().getFullYear(),
    n: autoCount + 1
  })
  const [addTogglePaymentIdx, setAddTogglePaymentIdx] = useState(true);
  const [paymentMode, setPaymentMode] = useState({});
  const [openPdf, setOpenPdf] = useState(false)
  const dispatch = useDispatch();
  
  useEffect(()=>{
    if (!recordData?._id) {
      dispatch(
        fetchAsyncGetPaymentNum())
        .then((res) => {
          const newPmt = res.payload?.pmtNo;
          let newNumber = 1;
          if (newPmt && newPmt?.n) {
            newNumber = newPmt?.n;
          }
          setPmtPrfx((prev) => {
            return {
              ...prev,
              n: newNumber + autoCount,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
        if(totalReceivableAmt){
          handleOnChange('amt',totalReceivableAmt);
        } 
    }
    else{
      setPmtPrfx(recordData?.pyNo)
      if(recordData?.mod){
        const payMod = allPaymentMode.find(opt=> opt.id === recordData?.mod)
        setPaymentMode(payMod)
      }
    }
  },[])
 

 

  return (
    <>
    <div
      className={`payment-listing_box ${addTogglePaymentIdx ? "show" : "hide"}`}
    >
      <div className="payment-list_array">
        <Box display="flex" justifyContent="space-evenly">
          <span className="payment-details">Payment # - <span style={{color:'#3291e6'}}>{pmtNumberFormate(pmtPrfx)}</span></span>
          <span className="amountSpan" style={{ marginLeft: "1rem" }}>
            {currency?.symbol || "₹" } {formatAmountIndianRupees(recordData?.amt || 0)}
          </span> 
         
        </Box>
        <div className="d-flex payment-pdf-icon"></div>

        <div className="d-flex">
          {recordData?._id &&
          <div className="d-flex">
            
              <Tooltip
                label="Payment Receipt"
                placement="bottom"
                hasArrow
                className="common-tooltip"
              >
                <div
                  onClick={() => {
                    setOpenPdf(!openPdf);
                  }}
                  className="ledger-icon"
                  style={{ cursor: "pointer" }}
                >
                  <TbListDetails />
                </div>
              </Tooltip>
          </div>
          }
          {["Admin", "Manager", "Accountant"].includes(role) &&
              <div className="d-flex mx-3">
                <span className="mt">
                  <FaTrash
                    style={{
                      fontSize: "16px",
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={deleteRecord}
                  />
                </span>
              </div>
          }
          <DrawerButton
            isOpen={addTogglePaymentIdx}
            handleClick={() => {
              setAddTogglePaymentIdx(!addTogglePaymentIdx);
            }}
          />
        </div>
      </div>

      <div
        className={`payment-inner_box ${
          addTogglePaymentIdx ? "show-content" : "hide-content"
        }`}
      >
        <Row className="">
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
                Amount Received <span className="span-star">*</span>
              </Form.Label>
              <Box>
                <InputGroup>
                  <InputGroup.Text>
                    <span className="rupee-symbol">{currency?.symbol || "₹" }</span>{" "}
                  </InputGroup.Text>
                  <CurrencyFormat
                    customInput={Form.Control}
                    type="text"
                    name="amt"
                    onValueChange={(e) => {
                      handleOnChange('amt',e.value);
                    }}
                    placeholder="0.00"
                    value={recordData?.amt || ""}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </InputGroup>
              </Box>
            </Box>
            <p className="form_error">
              {" "}
              {paymentRecordError[`record.${autoCount}.amt`]}
            </p>
          </Col>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
                Bank Charges (if any)
              </Form.Label>
              <Box>
                <InputGroup>
                  <InputGroup.Text>
                    <span className="rupee-symbol">{currency?.symbol || "₹" }</span>{" "}
                  </InputGroup.Text>
                  <CurrencyFormat
                    customInput={Form.Control}
                    type="text"
                    name="crg"
                    onValueChange={(e) => {
                      handleOnChange('crg',e.value);
                    }}
                    disabled={!recordData?.amt}
                    placeholder="0.00"
                    value={recordData?.crg}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </InputGroup>
              </Box>
            </Box>
            <p className="form_error">
              {" "}
              {paymentRecordError[`record.${autoCount}.crg`]}
            </p>
          </Col>
        </Row>
       
        <Row>
        <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
              Payment Date <span className="span-star">*</span>
              </Form.Label>
              <Box>
                <DatePicker
                  name="dt"
                  className="monthDate"
                  dateFormat="dd-MMM-yyyy"
                  selected={
                    recordData?.dt
                      ? new Date(recordData.dt)
                      : new Date()
                  }
                  onChange={(date) => {
                    handleOnChange('dt',date);
                  }}
                  onFocus={() => {
                    if (!recordData?.dt) {
                      handleOnChange('dt',new Date());
                    }
                  }}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </Box>
            </Box>
            <p className="form_error">
              {" "}
              {paymentRecordError[`record.${autoCount}.dt`]}
            </p>
          </Col>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>Payment Mode <span className="span-star">*</span></Form.Label>
              <VendorCustomSelect
                options={allPaymentMode}
                placeHolder={<div>Type or select...</div>}
                onChange={(newValue) => {
                  handleOnChange("mod",newValue?.id);
                  setPaymentMode(newValue);
                }}
                isSearchable
                defaultValue={paymentMode}
                role={role}
              />
              </Box>
              <p className="form_error">
              {" "}
              {paymentRecordError[`record.${autoCount}.mod`]}
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
                Reference#
              </Form.Label>
              <Box>
                <Form.Control
                  type="text"
                  name="ref"
                  placeholder="Reference Number"
                  onChange={(e) => {
                    handleOnChange('ref',e.target.value);
                  }}
                  value={recordData?.ref}
                />
              </Box>
            </Box>
          
          </Col>
          <Col>
            {paymentMode?.value === "Bank Transfer" && <Box display="flex" className="input-box">
              <Form.Label>
                Bank Name
              </Form.Label>

              <CustomSelect
                options={bankOptions}
                placeHolder={<div>Type or select...</div>}
                onChange={(newValue) =>
                  handleOnChange('selectedBank', newValue)
                }
                hideActions
                isSearchable
                defaultValue={recordData?.selectedBankId && bankOptions?.find(b => b.value === recordData?.selectedBankId)}
                role={role}
              />
            </Box>}
          </Col>
        </Row>
       
      </div>
      
     
    </div>
    {openPdf && (
        <div className="payment-mode-pdf">
          <PaymentReceiptPdf
            isOpen={openPdf}
            expenseData={editData}
            paymentData={{...recordData,paymentMode,pmtPrfx}}
            autoCount={autoCount}
            onClose={() => setOpenPdf(!openPdf)}
            expenseType={expenseType}
            currency={currency}
          />
        </div>
      )}
    </>
  );
};

export default PaymentRecords;
